export const BankIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.561 2.296a1.5 1.5 0 0 1 .878 0l2.24.689c1.167.359 2.277.886 3.292 1.567.79.528.416 1.76-.535 1.76H3.564c-.951 0-1.325-1.232-.536-1.76a12.525 12.525 0 0 1 3.294-1.568l2.24-.688Zm.548 1.076a.375.375 0 0 0-.218 0l-2.239.688a11.4 11.4 0 0 0-2.527 1.128h9.75a11.402 11.402 0 0 0-2.527-1.128l-2.24-.688Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M3.188 16.25a.562.562 0 0 1 .562-.563h10.5a.562.562 0 1 1 0 1.126H3.75a.563.563 0 0 1-.563-.563Zm1.5-3a.562.562 0 1 0 1.125 0v-4.5a.563.563 0 1 0-1.125 0v4.5ZM9 13.813a.563.563 0 0 1-.563-.563v-4.5a.563.563 0 1 1 1.126 0v4.5a.562.562 0 0 1-.563.563Zm3.188-.563a.562.562 0 1 0 1.124 0v-4.5a.563.563 0 0 0-1.124 0v4.5Z"
    />
  </svg>
);
